import request from '@/utils/request';

/* eslint-disable */
const actions = {
  async getVideos({ dispatch, commit, getters }, params = {}) {
    try {
      await commit('updateIsLoading', { isLoading: true });

      const { data } = await request.get('/videos', {
        params,
      });

      if (data.error) {
        throw Error('Server-side validation failed');
      }

      await commit('setData', data.videos);

      await commit('updateIsLoading', { isLoading: false });
    } catch (err) {
      await commit('updateIsLoading', { isLoading: false });

      throw err;
    }
  },
};

export default actions;
